



























































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MovingDetail from "@/components/contract-moving/movingDetail.vue";
import User, { USER_ROLE } from "@/model/user";
import { namespace } from "vuex-class";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QWitnessSelect from "@/common/qWitnessSelect.vue";
import QErrors from "@/common/qErrors.vue";
import QCalendar from "@/common/qCalendar.vue";
import ContractMoveOut, {
  CHECKLIST_STATUS,
  ContractMoveOutCheckList,
  CONTRACT_STEP,
} from "@/model/contractMoveOut";
import qNotify from "@/common/qNotify";
import QPolygonFloor, { drawMode } from "@/common/qPolygonFloor.vue";
import QMasterDirectionSelect from "@/common/qMasterDirectionSelect.vue";
import QFaceSelect from "@/common/qFaceSelect.vue";
import QMaterialSelect from "@/common/qMaterialSelect.vue";
import QRepairDetailSelect from "@/common/qRepairDetailSelect.vue";
import QFloorAreaSelect from "@/common/qFloorAreaSelect.vue";
import RepairContentPopup from "@/components/contract-moving/repairContentPopup.vue";
import _ from "lodash";
import CheckPointPopup from "@/components/contract-moving/checkPointPopup.vue";
import { CheckPoint } from "@/store/modules/confirmContract";
import QUnitNameSelect from "@/common/qUnitNameSelect.vue";
import { v4 as uuidv4 } from "uuid";
import VueScrollTo from "vue-scrollto";
import Face from "@/model/face";
import UnitName from "@/model/unitName";
import Repair from "@/model/repair";
import MasterDirection from "@/model/masterDirection";
import {compareWithKeys} from "@/common/utils";
// eslint-disable-next-line @typescript-eslint/no-var-requires
var starImage = require("@/assets/images/iconmonstr-star-6-24.png");

const auth = namespace("Auth");
const moveOutStore = namespace("MoveOut");
const masterStore = namespace("Master");
const routerStore = namespace("Router");
@Component({
  name: "StepSchedule",
  components: {
    MovingDetail,
    QUserSelect,
    QWitnessSelect,
    QErrors,
    QCalendar,
    QPolygonFloor,
    QMasterDirectionSelect,
    QFaceSelect,
    QMaterialSelect,
    QRepairDetailSelect,
    QFloorAreaSelect,
    RepairContentPopup,
    CheckPointPopup,
    QUnitNameSelect,
  },
})
export default class StepSchedule extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;

  // from data master
  @masterStore.Getter
  getFaces!: Face;
  @masterStore.Getter
  getUnits!: UnitName;
  @masterStore.Getter
  getRepairs!: Repair;
  @masterStore.Getter
  getDirections!: MasterDirection;

  @routerStore.Getter
  public getSearchParameters!:any;

  @Prop({ default: true })
  isEdit;
  @Prop({ default: "CheckList" })
  mode: "Correct" | "CheckList";

  public moveOutObject: ContractMoveOut = new ContractMoveOut();
  public moveOutObjectInit: ContractMoveOut = new ContractMoveOut();

  public userRole = USER_ROLE;
  public showPopup = false;
  public errors = {};
  public dateConfig = {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
  };
  public desired_date = null;
  public selected = null;
  public rowSelected = null;
  public imgStart = null;
  public isShowSavePopup = false;
  public floorPlanAreaID = null;

  mounted() {
    this.moveOutObject = new ContractMoveOut(_.cloneDeep(this.getMoveOut));
    this.moveOutObject.in_charge_id = this.getUserLogging.id;
    this.imgStart = document.createElement("img");
    this.imgStart.src = starImage;

    if (this.moveOutObject.contract_moving_out_check_list.length === 0) {
      this.moveOutObject.addNewCheckList();
    }
    if (this.moveOutObject.step === CONTRACT_STEP.STEP_CHECKLIST) {
      // cover case go back after correction step
      this.moveOutObject.contract_moving_out_check_list.map((item) => {
        item.field_updated = [];
        return item;
      });
    }
    this.generatorPolygon();
    this.moveOutObjectInit = _.cloneDeep(this.moveOutObject)
  }

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  public getStatusName(statusName) {
    if (this.moveOutObject.step === CONTRACT_STEP.STEP_CHECKLIST) {
      return "";
    }
    return statusName;
  }

  public addNew() {
    this.moveOutObject.addNewCheckList(
      this.mode === "Correct" ? CHECKLIST_STATUS.NEW : CHECKLIST_STATUS.DEFAULT
    );
  }

  public generatorPolygon() {
    // const { clientWidth, clientHeight } = this.$refs.CheckPointArea as Element;
    (this.$refs.floorEditor as QPolygonFloor).setConfig({
      areaOptions: {
        selectable: false,
      },
    });
    (this.$refs.floorEditor as QPolygonFloor).disableTouch();
    (this.$refs.floorEditor as QPolygonFloor).loadObject(
      this.moveOutObject.property.floor_plan.svg_object,
      this.moveOutObject.property.floor_plan.areas,
      drawMode.checkPoint,
      {
        width: 600,
        height: 600,
      }
    );
    // render check list
    if (this.moveOutObject.contract_moving_out_check_list) {
      this.moveOutObject.contract_moving_out_check_list.map((item) => {
        item.is_show_checkpoint && this.onChangeFloorArea(item);
      });
      this.onSelectedRow(this.moveOutObject.contract_moving_out_check_list[0]);
    }
    // render resident marked
    this.renderCustomerCheckPoint();
  }

  public renderCustomerCheckPoint() {
    if (this.moveOutObject.customer_checkout_points) {
      let areaIds = this.moveOutObject.customer_checkout_points.map((item) => {
        return {
          floor_plan_area_id: item.floor_plan_area_id,
          id: item.id,
        };
      });
      // have transform to checklist then bypass
      areaIds = areaIds.filter((item) => {
        return (
          this.moveOutObject.contract_moving_out_check_list.findIndex(
            (checkList) => checkList.from_customer_check_list_id === item.id
          ) === -1
        );
      });
      (this.$refs.floorEditor as QPolygonFloor).selectAreas(
        areaIds,
        this.imgStart
      );
    }
  }

  public onChangeFloorArea(checkoutPoint: ContractMoveOutCheckList) {
    checkoutPoint.is_show_checkpoint &&
      (this.$refs.floorEditor as QPolygonFloor).selectCheckPoint(
        {
          groupId: checkoutPoint.floor_area_id,
          id: checkoutPoint.id || checkoutPoint._id,
          text: checkoutPoint.order + "",
        },
        checkoutPoint.from_customer_check_list_id ? "Circle" : "Rect",
        checkoutPoint.svg_position
      );
  }

  public async cancel() {
    if (this.moveOutObject.contract_moving_out_check_list.length !== this.moveOutObjectInit.contract_moving_out_check_list.length) {
      this.cancelModal();
    } else if (this.moveOutObject.contract_moving_out_check_list.length > 0) {
      const isChange = await this.isChanged()
      if (isChange === false) {
        this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
      } else {
        this.cancelModal();
      }
    } else {
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    }
  }

  public async isChanged() {
    for (let key in this.moveOutObjectInit.contract_moving_out_check_list) {
      const isChange = compareWithKeys(this.moveOutObject.contract_moving_out_check_list[key] , this.moveOutObjectInit.contract_moving_out_check_list[key], [
        'floor_area_id', 'master_direction_id', 'face_id', 'material_id', 'remarks',
        'repair_detail_id', 'quantity', 'unit_name_id', 'unit_price', 'ratio_price',
      ]);
      if (isChange === false) {
        continue;
      }
      return true;
    }
    return false;
  }

  public cancelModal() {
    this.$modal.showCancel({
      text: this.$t("cancel"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
      },
    });
  }

  public selection(index) {
    return this.selected == index ? "select" : "";
  }

  get returnedItems() {
    return this.moveOutObject.contract
      ? this.moveOutObject.contract.returned_items
      : [];
  }

  public reject() {
    this.$modal.showCancel({
      title: "日程調整取消",
      text: `チェックリスト作成をリセットし、日程調整へステップを戻します。<br>
            この操作は取り消せません`,
      confirmText: "はい",
      cancelText: "キャンセル",
      confirmClass: "mb__button mb__w-100pc mb__add-color-red",
      cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
      type: "error",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        // this.$router.back();
        const result = await this.moveOutObject.goBack({
          step: CONTRACT_STEP.STEP_SCHEDULE,
        });
        if (result.meta.status === 200) {
          // return
          this.$router.replace({ query: { step: uuidv4() } });
          VueScrollTo.scrollTo({ force: true });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
          this.errors = result.meta.errors;
        }
      },
    });
  }

  public async submit() {
    const result = await this.moveOutObject.submitCheckList();
    if (result.meta.status === 200) {
      this.$router.replace({ query: { step: uuidv4() } });
      VueScrollTo.scrollTo({ force: true });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }

  public onSelectedRow(checkPoint: ContractMoveOutCheckList) {
    this.rowSelected = checkPoint.order;
    if (checkPoint.is_show_checkpoint) {
      this.onChangeFloorArea(checkPoint);
    } else {
      // clear select checkpoint
      (this.$refs.floorEditor as QPolygonFloor).clearSelectedCheckPoint();
    }
  }

  public onSelectCheckPoint(point: any) {
    if (point.type === "group_checkpoint") {
      const checkPoint = this.moveOutObject.contract_moving_out_check_list.find(
        (item) => {
          return item.id === point.id || item._id === point.id;
        }
      );
      if (checkPoint) {
        this.rowSelected = checkPoint.order;
      }
      this.editCheckPoint(checkPoint);
    } else {
      const residentCheckPoint =
        this.moveOutObject.customer_checkout_points.find((item) => {
          return item.id === point.id || item._id === point.id;
        });
      this.resisdentViewPoint(residentCheckPoint);
    }
  }

  public actionRemoveCheckPoint(checkPoint: ContractMoveOutCheckList) {
    this.$modal.showDelete({
      text: this.$t("delete"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        this.removeCheckPoint(checkPoint);
      },
    });
  }

  public removeCheckPoint(checkPoint: ContractMoveOutCheckList) {
    if (this.mode === "Correct" && checkPoint.id) {
      const checkList = this.moveOutObject.contract_moving_out_check_list.find(
        (item) => item.id === checkPoint.id
      );
      checkList.status = CHECKLIST_STATUS.DELETE;
    } else {
      (this.$refs.floorEditor as QPolygonFloor).removeObject(
        checkPoint.id || checkPoint._id
      );
      this.moveOutObject.removeCheckPoint(checkPoint);
      this.rowSelected = null;
      // fix text
      (this.$refs.floorEditor as QPolygonFloor).changeTextPoint(
        this.moveOutObject.contract_moving_out_check_list.map((item) => {
          return {
            text: item.order + "",
            id: item.id || item._id,
          };
        })
      );
    }
  }

  public showRepairHistory(floor_area_id) {
    (this.$refs.repairPopup as RepairContentPopup).show({
      property_id: this.moveOutObject.property.id,
      floor_area_id: floor_area_id,
    });
  }

  public editCheckPoint(checkPoint: ContractMoveOutCheckList) {
    let customerCheckList = null;
    if (checkPoint.from_customer_check_list_id) {
      customerCheckList = this.moveOutObject.customer_checkout_points.find(
        (item) => item.id === checkPoint.from_customer_check_list_id
      );
    }
    (this.$refs.checkPointPopup as CheckPointPopup).show(
      checkPoint,
      this.moveOutObject.property,
      this.isEdit ? "Edit" : "Detail",
      customerCheckList,
      this.mode
    );
  }

  public resisdentViewPoint(checkPoint: CheckPoint) {
    const fakeCheckList = new ContractMoveOutCheckList(checkPoint);
    fakeCheckList.floor_area_id = checkPoint.floor_plan_area_id;
    fakeCheckList.repair_image_id = checkPoint.images;
    fakeCheckList.is_show_checkpoint = true;
    fakeCheckList.floor_area =
      this.moveOutObject.property.floor_plan.areas.find((item) => {
        return item.id === fakeCheckList.floor_area_id;
      });
    (this.$refs.checkPointPopup as CheckPointPopup).show(
      fakeCheckList,
      this.moveOutObject.property,
      "Resident"
    );
  }

  public changeImage(checkPoint: ContractMoveOutCheckList) {
    const checkPointOriginal =
      this.moveOutObject.contract_moving_out_check_list.find(
        (item) =>
          (item.id && item.id === checkPoint.id) || item._id === checkPoint._id
      );
    if (checkPointOriginal) {
      checkPointOriginal.repair_image_id = checkPoint.repair_image_id;
      // set area and position
      checkPointOriginal.floor_area_id = checkPoint.floor_area_id;
      checkPointOriginal.floor_area = checkPoint.floor_area;
      checkPointOriginal.is_show_checkpoint = checkPoint.is_show_checkpoint;
      // convert to current ratio
      checkPointOriginal.svg_position = checkPoint.svg_position;
      // const { x, y } = this.getCurrentRatioSize();
      // checkPointOriginal.svg_position = {
      //   left: checkPoint.svg_position.left - checkPoint.svg_position.left * x,
      //   top: checkPoint.svg_position.top - checkPoint.svg_position.top * y,
      // };
      if (checkPointOriginal.is_show_checkpoint) {
        this.onChangeFloorArea(checkPointOriginal);
      } else {
        (this.$refs.floorEditor as QPolygonFloor).removeObject(
          checkPoint.id || checkPoint._id
        );
      }
    }
  }

  public getCurrentRatioSize() {
    const { clientWidth, clientHeight } = this.$refs.CheckPointArea as Element;
    // 700x600
    return {
      x: 1 - clientWidth / 600,
      y: 1 - clientHeight / 600,
    };
  }

  public addAsResidentPoint(checkPoint: CheckPoint) {
    // add to first item if not select area
    const lastCheckList =
      this.moveOutObject.contract_moving_out_check_list[
        this.moveOutObject.contract_moving_out_check_list.length - 1
      ];
    if (!lastCheckList.isModifier) {
      this.moveOutObject.contract_moving_out_check_list.pop();
    }
    const checkList = this.moveOutObject.addNewCheckList();
    checkList.floor_area_id = checkPoint.floor_plan_area_id;
    checkList.floor_area = this.moveOutObject.property.floor_plan.areas.find(
      (item) => {
        return item.id === checkList.floor_area_id;
      }
    );
    checkList.from_customer_check_list_id = checkPoint.id;
    checkList.is_show_checkpoint = true;
    checkList.repair_image_id = checkPoint.images;
    checkList.status = CHECKLIST_STATUS.NEW;
    this.renderCustomerCheckPoint();
    // this.onChangeFloorArea(checkList);
    this.onSelectedRow(checkList);
  }

  public save() {
    this.moveOutObject.is_resolved = false;
    this.isShowSavePopup = true;
  }
  public async saveCheckList() {
    this.moveOutObject.is_changed =
      this.moveOutObject.getCheckListChange().length > 0;
    // case save must be validate message
    if (
      !this.moveOutObject.is_resolved &&
      !this.moveOutObject.is_changed &&
      !this.moveOutObject.message
    ) {
      this.errors = {
        ...this.errors,
        message: [this.$t("move_out.message_required")],
      };
      return;
    }
    const result = await this.moveOutObject.correctCheckList();
    if (result.meta.status === 200) {
      this.isShowSavePopup = false;
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }
  public async resign() {
    const result = await this.moveOutObject.reSignature();
    if (result.meta.status === 200) {
      this.$router.replace({ query: { step: uuidv4() } });
      VueScrollTo.scrollTo({ force: true });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
    }
  }
  public approval() {
    this.moveOutObject.is_resolved = true;
    this.isShowSavePopup = true;
  }

  public async withRawApproval() {
    this.$modal.showCancel({
      title: "承認取消",
      text: `チェックリストの承認を取り消します。`,
      confirmText: "はい",
      cancelText: "キャンセル",
      confirmClass: "mb__button mb__w-100pc mb__add-color-red",
      cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
      type: "error",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await this.moveOutObject.goBack({
          step: CONTRACT_STEP.STEP_CORRECT_CHECK_LIST,
        });
        if (result.meta.status === 200) {
          this.$router.replace({ query: { step: uuidv4() } });
          VueScrollTo.scrollTo({ force: true });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
          this.errors = result.meta.errors;
        }
      },
    });
  }

  public async repairRequest() {
    const result = await this.moveOutObject.repairRequest();
    if (result.meta.status === 200) {
      this.$router.replace({ query: { step: uuidv4() } });
      VueScrollTo.scrollTo({ force: true });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }

  public canDeleteCheckList(checkList: ContractMoveOutCheckList) {
    return !checkList.from_customer_check_list_id || this.mode === "Correct";
  }
}
